
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoahmedabadcabservice() {



    const cardData =
    {
        keyword: 'Pune to Ahmedabad Cab Service ',
        heading: 'Platinum24 Cabs: Pune to Ahmedabad Cab Service',
        headingDescription: ' Platinum24 Cabs provides trusted Pune to Ahmedabad cab services, ideal for business trips, pilgrimages, and family travel. Whether you’re heading to Ahmedabad for corporate meetings, visiting the Sabarmati Ashram, or exploring cultural landmarks like Kankaria Lake and Akshardham Temple, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable and safe ride. With professional chauffeurs, punctual pickups, and transparent pricing, we make long-distance travel stress-free. From one-way journeys to return packages, Platinum24 Cabs guarantees a smooth and reliable Pune to Ahmedabad cab experience.',

        top: 'Top Places to Visit in Ahmedabad with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Sabarmati Ashram",
    "description": "Sabarmati Ashram, founded by Mahatma Gandhi in 1917, was the epicenter of India’s freedom struggle. It was from here that Gandhi launched the historic Dandi March in 1930. The ashram houses Hriday Kunj, Gandhi’s residence, and a museum showcasing his personal items, letters, and photographs. Its peaceful riverside location makes it inspiring for visitors. Students, researchers, and tourists find it deeply moving. Sabarmati Ashram is Ahmedabad’s spiritual and historic pride."
  },
  {
    "title": "Kankaria Lake",
    "description": "Kankaria Lake, built in the 15th century, is Ahmedabad’s most popular leisure spot. The lakefront features gardens, a zoo, toy train, amusement park, and hot-air balloon rides. Families enjoy evening strolls and boating on its waters. The annual Kankaria Carnival adds festive vibes with cultural programs. Night lighting makes the lakefront enchanting. Kankaria Lake is Ahmedabad’s hub of recreation and fun."
  },
  {
    "title": "Sidi Saiyyed Mosque",
    "description": "Sidi Saiyyed Mosque, built in 1573, is renowned for its iconic stone latticework windows. The ‘Tree of Life’ jali is world-famous and symbolizes Indo-Islamic artistry. Tourists and photographers admire the delicate carvings. It is an important spiritual site and architectural landmark. The mosque has become a cultural symbol of Ahmedabad. Sidi Saiyyed Mosque is the city’s timeless heritage jewel."
  },
  {
    "title": "Adalaj Stepwell",
    "description": "Adalaj Stepwell, located near Ahmedabad, is a 15th-century marvel of Indo-Islamic architecture. Built by Queen Rudabai, it features intricate carvings, pillars, and platforms across five stories. Travelers explore its underground corridors, which once provided water and shelter. The stepwell’s design allows sunlight to filter beautifully. It remains a favorite of history lovers and photographers. Adalaj Stepwell is Ahmedabad’s architectural masterpiece."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, built in 1424 by Sultan Ahmed Shah, is one of India’s most beautiful mosques. Its yellow sandstone structure combines Hindu and Islamic architectural styles. The mosque has 260 columns supporting intricately carved domes. Its vast courtyard accommodates thousands of worshippers. Visitors admire its symmetry and grandeur. Jama Masjid is Ahmedabad’s historic spiritual hub."
  },
  {
    "title": "Calico Museum of Textiles",
    "description": "The Calico Museum is one of the world’s finest textile museums, showcasing India’s rich weaving and fabric traditions. Established in 1949, it houses ancient fabrics, royal costumes, Kashmiri shawls, and Mughal textiles. Exhibits narrate India’s artistic and cultural history through cloth. Guided tours make the experience insightful. Textile enthusiasts and designers find it especially valuable. The Calico Museum is Ahmedabad’s cultural knowledge hub."
  },
  {
    "title": "Sabarmati Riverfront",
    "description": "The Sabarmati Riverfront is a modern development offering walkways, gardens, and cultural spaces along the river. Tourists enjoy cycling, boating, and evening strolls here. Festivals, exhibitions, and flower shows are often hosted on the promenade. The riverfront is beautifully lit at night. It has transformed into a recreational and urban landmark. Sabarmati Riverfront is Ahmedabad’s scenic lifestyle destination."
  },
  {
    "title": "Science City",
    "description": "Science City in Ahmedabad is an educational and entertainment hub for families and students. Attractions include a planetarium, IMAX theater, 3D shows, energy park, and robotics gallery. Interactive exhibits make learning fun and engaging. The musical fountain and exhibitions attract large crowds. It blends science with recreation for all age groups. Science City is Ahmedabad’s futuristic wonderland."
  },
  {
    "title": "Bhadra Fort",
    "description": "Bhadra Fort, built in 1411 by Sultan Ahmed Shah, is a historic fort in the old city. It once housed royal palaces, mosques, and gardens. Legends speak of hidden treasures buried here. The fort also has the Teen Darwaza, a triple-arched gateway. Today it hosts government offices and cultural events. Bhadra Fort is Ahmedabad’s symbol of medieval power."
  },
  {
    "title": "Manek Chowk",
    "description": "Manek Chowk is Ahmedabad’s most famous square, serving as a jewelry market by day and a bustling food street by night. Street vendors serve pav bhaji, dosa, kulfi, and local delicacies till late hours. The lively atmosphere attracts locals and tourists alike. The market is surrounded by heritage havelis and temples. It is a paradise for foodies and shoppers. Manek Chowk is Ahmedabad’s cultural heartbeat."
  }
],


              "services": [
    {
      "name": "Pune to Ahmedabad Cab",
      "description": "Travel comfortably with our Pune to Ahmedabad Cab service, offering safe, timely, and reliable transportation between the two cities. Our well-maintained vehicles and professional drivers ensure a hassle-free long-distance journey."
    },
    {
      "name": "Pune to Ahmedabad Taxi",
      "description": "Choose our Pune to Ahmedabad Taxi for affordable and convenient interstate travel. Whether for business or leisure, our experienced drivers and clean cars make your journey smooth and enjoyable."
    },
    {
      "name": "Book Pune to Ahmedabad Cab",
      "description": "Easily Book Pune to Ahmedabad Cab online with instant confirmation and transparent pricing. Select your preferred vehicle and enjoy hassle-free booking with flexible pickup options."
    },
    {
      "name": "Pune to Ahmedabad Car Hire",
      "description": "Explore Pune to Ahmedabad with our flexible Car Hire service, offering self-drive and chauffeur-driven options. Choose from sedans, SUVs, or luxury cars to suit your travel needs."
    },
    {
      "name": "Pune to Ahmedabad One Way Taxi",
      "description": "Opt for our Pune to Ahmedabad One Way Taxi service for cost-effective, single-direction travel. Ideal for relocations, business trips, or one-way journeys without paying for the return leg."
    },
    {
      "name": "Cab Service from Pune to Ahmedabad",
      "description": "Our Cab Service from Pune to Ahmedabad provides reliable, comfortable, and affordable transportation with professional drivers and well-maintained vehicles, ensuring your trip is smooth and stress-free."
    },
    {
      "name": "Pune to Ahmedabad Cab Fare",
      "description": "Get upfront information on Pune to Ahmedabad Cab Fare with our transparent pricing system. No hidden charges, so you can plan your travel budget with confidence."
    },
    {
      "name": "Affordable Cabs Pune to Ahmedabad",
      "description": "Travel smart with our Affordable Cabs from Pune to Ahmedabad. Perfect for budget-conscious travelers seeking quality service and comfort without breaking the bank."
    },
    {
      "name": "Pune to Ahmedabad Cab Booking",
      "description": "Book your Pune to Ahmedabad Cab easily through our platform, offering quick confirmations, flexible timings, and multiple payment options for a seamless experience."
    },
    {
      "name": "Pune to Ahmedabad Outstation Taxi",
      "description": "Our Pune to Ahmedabad Outstation Taxi service is designed for long-distance travelers needing spacious vehicles, expert drivers, and reliable service on highway routes."
    },
    {
      "name": "Pune to Ahmedabad Taxi Charges",
      "description": "Check Pune to Ahmedabad Taxi Charges before you travel with our clear and detailed fare breakdowns, ensuring complete transparency and no surprises."
    }
  ],
  "tableData": [
    ["Pune to Ahmedabad Cab", "Pune to Ahmedabad Taxi"],
    ["Book Pune to Ahmedabad Cab", "Pune to Ahmedabad Car Hire"],
    ["Pune to Ahmedabad One Way Taxi", "Cab Service from Pune to Ahmedabad"],
    ["Pune to Ahmedabad Cab Fare", "Affordable Cabs Pune to Ahmedabad"],
    ["Pune to Ahmedabad Cab Booking", "Pune to Ahmedabad Outstation Taxi"],
    ["Pune to Ahmedabad Taxi Charges", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Ahmedabad Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs provides reliable and comfortable cab services for your journey from Pune to Ahmedabad, ensuring a smooth and enjoyable ride."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Every Group Size",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers to suit your travel needs between Pune and Ahmedabad."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Your Safety",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Ahmedabad Routes",
    "WhyChoosedescription": "Our skilled drivers know the best routes between Pune and Ahmedabad to ensure timely and smooth travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent fares that include fuel, tolls, and driver allowances for hassle-free travel."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist you with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Short and Long-Term Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans to suit your Pune to Ahmedabad travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Ahmedabad cab quickly and securely through our website or app with real-time confirmation."
  }
]



















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Ahmedabad cab service?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services from Pune to Ahmedabad with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Ahmedabad?',
        answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Ahmedabad travel?',
        answer: 'We offer hatchbacks, sedans, SUVs, and luxury cars to suit your travel preferences and budget.',
    },
    {
        question: 'Is one-way cab service available from Pune to Ahmedabad?',
        answer: 'Yes, we provide both one-way and round-trip cab services for Pune to Ahmedabad.',
    },
    {
        question: 'Are the drivers experienced for Pune to Ahmedabad long-distance travel?',
        answer: 'Absolutely, our drivers are licensed, experienced, and familiar with the Pune to Ahmedabad route.',
    },
    {
        question: 'Can I customize my pickup and drop-off locations in Pune and Ahmedabad?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points as per your convenience.',
    },
    {
        question: 'What safety and hygiene measures are followed for Pune to Ahmedabad cabs?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety and hygiene protocols.',
    },
    {
        question: 'Is Pune to Ahmedabad cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Ahmedabad cab bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Ahmedabad cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and all major credit/debit cards.',
    },
    {
        question: 'Are there customizable packages for Pune to Ahmedabad cab service?',
        answer: 'Yes, we offer flexible packages that can be tailored to your travel needs and preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Manish Shah',
        feedback: 'The Pune to Ahmedabad cab service was excellent — punctual, clean vehicle, and friendly driver.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Rina Desai',
        feedback: 'Highly recommend Platinum24 Cabs for Pune to Ahmedabad travel. Comfortable and hassle-free experience.',
        rating: 5,
    },
];









































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const puneToAhmedabadCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ahmedabad Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-ahmedabad-cab.jpg",
  "description": "Book Pune to Ahmedabad cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable and available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5799",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-ahmedabad-cab-service"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Ahmedabad Cab Service | Affordable Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Ahmedabad cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable and available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Ahmedabad Cab, Pune to Ahmedabad Taxi, Book Pune to Ahmedabad Cab, Pune to Ahmedabad Car Hire, Pune to Ahmedabad One Way Taxi, Cab Service from Pune to Ahmedabad, Pune to Ahmedabad Cab Fare, Affordable Cabs Pune to Ahmedabad, Pune to Ahmedabad Cab Booking, Pune to Ahmedabad Outstation Taxi, Pune to Ahmedabad Taxi Charges"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToAhmedabadCabSchema)}
  </script>
</Helmet>




            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/103.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoahmedabadcabservice;